import { render, staticRenderFns } from "./BodyDeParcelas.vue?vue&type=template&id=36966d9c&scoped=true"
import script from "./BodyDeParcelas.vue?vue&type=script&setup=true&lang=js"
export * from "./BodyDeParcelas.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BodyDeParcelas.vue?vue&type=style&index=0&id=36966d9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36966d9c",
  null
  
)

export default component.exports